export default {
  'productiveHoursCost.form.costPerEmployee': 'Custo por funcionário (%)',

  'productiveHoursCost.form.filterByDate': 'Filtrar por data de',
  'productiveHoursCost.form.filterByDate.entrance': 'Entrada',
  'productiveHoursCost.form.filterByDate.authorization': 'Autorização',
  'productiveHoursCost.form.filterByDate.shutdown': 'Fechamento',
  'productiveHoursCost.form.filterByDate.exit': 'Saída',

  'productiveHoursCost.form.situation': 'Situação',
  'productiveHoursCost.form.situation.open': 'Entrada',
  'productiveHoursCost.form.situation.authorized': 'Autorizados',
  'productiveHoursCost.form.situation.closed': 'Fechados',
  'productiveHoursCost.form.situation.canceled': 'Cancelados',

  'productiveHoursCost.form.type': 'Tipo',
  'productiveHoursCost.form.type.workOrder': 'Orçamento',
  'productiveHoursCost.form.type.warranty': 'Garantia',
  'productiveHoursCost.form.type.return': 'Retorno',
  'productiveHoursCost.form.type.courtesy': 'Cortesia',
  'productiveHoursCost.form.type.insideCourtesy': 'Interna (Cortesia)',
  'productiveHoursCost.form.type.totalLoss': 'Perda total',
  'productiveHoursCost.form.type.revision': 'Revisão',

  'productiveHoursCost.form.moreOption.employees': 'Funcionários',
  'productiveHoursCost.form.moreOption.area': 'Área',
};
